<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2339_29446)">
<rect x="17.3486" y="2.46772" width="3.30271" height="25.3656" rx="1.65136" stroke="currentColor" stroke-width="1.4"/>
<rect x="17.9387" y="7.77832" width="2.12266" height="8.37231" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2339_29446">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
